import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Project} from "../../dm/project";

export interface DeleteContainerModalData {
    isRunning: boolean;
    isContainerInstance: boolean;
    isContainerInstances: boolean;
}
@Component({
    selector: 'app-delete-container-modal',
    templateUrl: './delete-container-modal.component.html',
    styleUrls: ['./delete-container-modal.component.css']
})
export class DeleteContainerModalComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<DeleteContainerModalComponent>,
                @Inject(MAT_DIALOG_DATA) public data: DeleteContainerModalData
    ) {
    }

    ngOnInit() {
        // do nothing.
    }

    onSubmit() {
        this.dialogRef.close(true);
    }

    onClose() {
        this.dialogRef.close();
    }
}
